import React from "react";
import { dispatch } from "@rematch/core";
import { Form } from "formsy-semantic-ui-react";
import {
  Button,
  Header,
  Modal,
  Grid,
  Divider,
  List,
  Image,
  Checkbox,
  TextArea,
} from "semantic-ui-react";
import { toastr } from "react-redux-toastr";
import Labels from "../../../../common/Labels";
import ImageAvater from "../../../../drive/Components/ImageAvater";
import EllipsisTooltip from "../../../../common/EllipsisTooltip";
import defaultLogo from "../../../../../images/logo/logo-128.png";
import TextEditor from "../../../../common/TextEditor";
import _ from "lodash";

class ManageIntegrationsModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      reason: "",
      checked: false,
      allIntegrations: [],
      openDisabledModal: false,
      // selectedAccount: this.props.account ? this.props.account : null
    };
  }

  componentWillReceiveProps(newProps) {
    this.setState({ account: newProps.account });
    this.setState({ integrationsList: newProps.integrationsList });

    let newintegrationsArray = [];

    if (
      newProps.integrationsList &&
      newProps.integrationsList.data &&
      newProps.account
    ) {
      let updateIsActive = [];
      if (
        newProps.account.integrations &&
        newProps.account.integrations.length !== 0
      ) {
        for (let i = 0; i < newProps.account.integrations.length; i++) {
          newProps.account.integrations[i].id.isActive =
            newProps.account.integrations[i].isActive;
          newProps.account.integrations[i].id.reason =
            newProps.account.integrations[i].reason;
          updateIsActive.push(newProps.account.integrations[i].id);
        }
      }
      let mergeList = [...updateIsActive, ...newProps.integrationsList.data];
      newintegrationsArray = _.uniqBy(mergeList, "_id");
      newintegrationsArray = _.sortBy(newintegrationsArray, "label");
    }
      this.setState({ allIntegrations: newintegrationsArray });
  }
  handleClose = () => {
    this.setState({ reason: "", allIntegrations: [] });
    this.props.onCloseManageIntegrationPopup(false);
  };

  async deActivateAccount(formData) {
    let payload = {
      accountId: this.props.account._id,
      subscriptionId: this.props.account.subscriptionId,
      reason: this.state.reason,
    };
    await dispatch.account.deactivateAccount(payload);
    this.handleClose();
  }

  updateText = (data, name) => {
    if (name === "Reason") {
      if (data.replace(/<(.|\n)*?>/g, "").trim().length === 0) {
        this.setState({ reason: "" });
      } else {
        this.setState({ reason: data });
      }
    }
  };

  toggleChange = async (e, data) => {
    if (data.checked) {
      let message = (
        <div className="confirmMessage">
          <h3>Enable Integration </h3>
          <label>{data.integration.label}</label>
          <p>Are you sure to enable this integration?</p>
        </div>
      );
      toastr.confirm(message, {
        onOk: async () => {
          

          if (data.integration && data.integration.isActive === true) {
            const updatedIntegration = {...data.integration, isActive:true}
            let payload = {
              account: this.props.account,
              integrations: updatedIntegration,
              user: this.props.user,
              removeIntegration:true,
              toggleChecked:true
            };
            let newArray = _.sortBy(this.state.allIntegrations, "label");
            const index = newArray.findIndex(obj => obj._id === data.integration._id);
            if (index !== -1) {
              newArray[index].isActive = !newArray[index].isActive;
            }

            this.setState({ allIntegrations: newArray });
            // await dispatch.integrations.removeIntegrationsFromAccount(payload);
            await dispatch.integrations.addIntegrationInAccounts(payload);
          } else if (data.integration && data.integration.isActive === false) {
            const updatedIntegration = {...data.integration,isActive : true}
            let payload = {
              account: this.props.account,
              integrations: updatedIntegration,
              user: this.props.user,
              removeIntegration:true,
              toggleChecked:true
            };
            let newArray = this.state.allIntegrations;

            const newState = newArray.map((obj) =>
              obj._id === data.integration._id
                ? { ...obj, isActive: !obj.isActive }
                : obj
            );

            this.setState({ allIntegrations: newState });

            // await dispatch.integrations.removeIntegrationsFromAccount(payload);
            await dispatch.integrations.addIntegrationInAccounts(payload);
          } else {
            const updatedIntegration = {...data.integration,isActive:true}
            let payload = {
              account: this.props.account,
              integrations: updatedIntegration,
              user: this.props.user,
              removeIntegration:false,
              toggleChecked:true
            };
            let newArray = this.state.allIntegrations;

            const newState = newArray.map((obj) =>
              obj._id === data.integration._id
                ? { ...obj, isActive: !obj.isActive }
                : obj
            );

            this.setState({ allIntegrations: newState });
            await dispatch.integrations.addIntegrationInAccounts(payload);
          }
        },
      });
    } else {

      // this.setState({openDisabledModal:true})

      this.setState({ secondOpen: true, currentIntegration: data.integration });



    }


  };

  onDisableIntegration = async () => {
    let updatedDoc = {
      ...this.state.currentIntegration,
      isActive: false,
      reasonforDisable: this.state.disabledIntegrationreason

    }
    let payload = {
      account: this.props.account,
      integrations: updatedDoc,
      user: this.props.user,
      removeIntegration:true,
      toggleChecked:false
    };
    let newArray = this.state.allIntegrations;

    const newState = newArray.map((obj) =>
      obj._id === this.state.currentIntegration._id ? { ...obj, isActive: !obj.isActive } : obj
    );

    this.setState({ allIntegrations: newState,disabledIntegrationreason: undefined });


    // await dispatch.integrations.removeIntegrationsFromAccount(payload);
    await dispatch.integrations.addIntegrationInAccounts(payload);
    await this.setState({ secondOpen: false })
  };



  disableIntegrationReason = async (e, value) => {
    await this.setState({ disabledIntegrationreason: value.value });
  };


  closeDisableIntegrationModal = () => {
    this.setState({ secondOpen: false, disabledIntegrationreason: undefined })
  }


  render() {
    const errorLabel = (
      <div
        style={{ padding: "5px 0px 0px 6px" }}
        className="customErrorLabel"
      />
    );
    const { account, integrationsList } = this.props;
    let integrationsArr = [];
    if (integrationsList && integrationsList.data && account) {
      let updateIsActive = [];
      if (account.integrations && account.integrations.length !== 0) {
        for (let i = 0; i < account.integrations.length; i++) {
          account.integrations[i].id.isActive =
            account.integrations[i].isActive;
          account.integrations[i].id.reason = account.integrations[i].reason;
          updateIsActive.push(account.integrations[i].id);
        }
      }
      let mergeList = [...updateIsActive, ...integrationsList.data];
      integrationsArr = _.uniqBy(mergeList, "_id");
      integrationsArr = _.sortBy(integrationsArr, "label");
    }
    // if(integrationsList && integrationsList.data && account){
    //   this.setState({allIntegrations:integrationsArr})
    // }

    return (
      <div>
        <Modal
          open={this.props.open}
          onClose={this.handleClose}
          size="tiny"
          className="basicModal"
          closeOnEscape={true}
          closeOnDimmerClick={false}
          closeIcon
        >
          <Header
            style={{ margin: "0px 0px 10px 0" }}
            content={"Manage Integrations"}
          ></Header>
          <Form
            noValidate
            ref={(ref) => (this.form = ref)}
            id="deactivateAccount"
            preventExternalInvalidation={true}
            onValidSubmit={(event) => {
              this.deActivateAccount(event);
            }}
            className="formcyForm"
          >
            <Modal.Content>
              <Grid>
                <Grid.Row
                  className=" bg-clr-lightBlue"
                  style={{ margin: "0 15px", paddingBottom: "0px" }}
                >
                  <Grid.Column width={8}>
                    <Labels
                      text={
                        <div>
                          <div className="accountLogoTiny">
                            <Image
                              className="mar_0"
                              src={
                                account && account.logo
                                  ? account.logo
                                  : defaultLogo
                              }
                            />
                          </div>
                          <div className="float-left mar_5">
                            <EllipsisTooltip
                              style={{ color: "#333" }}
                              name={account && account.name}
                            />
                          </div>
                        </div>
                      }
                    />
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <Labels
                      text={
                        <List horizontal>
                          <List.Item>
                            <ImageAvater
                              user={account && account.ownerId}
                              imageStyle="f_10 w_32 h_32 mar_0"
                            />
                            <div className="float-left f_12 pad_2 ">
                              <EllipsisTooltip
                                name={
                                  account &&
                                  account.ownerId.firstName +
                                  " " +
                                  account.ownerId.lastName
                                }
                                line={2}
                                style={{
                                  lineHeight: "14px",
                                  padding: "0px 0px 2px 0px",
                                  color: "#333",
                                }}
                              />
                              <span className="float-left f_10 pad_2 clr-dark-gray ">
                                <EllipsisTooltip
                                  name={account && account.ownerId.email}
                                  line={2}
                                  style={{ lineHeight: "14px", color: "#333" }}
                                />
                              </span>
                            </div>
                          </List.Item>
                        </List>
                      }
                    />
                  </Grid.Column>
                </Grid.Row>
                <Divider style={{ margin: "5px 0" }} />
                <Grid.Row style={{ margin: "0px 0px", paddingBottom: "0px" }}>
                  <Grid.Column width={16}>
                    {integrationsList && integrationsList.data.length !== 0 ? (
                      <h3>
                        {integrationsList.data.length} {integrationsList.data.length === 1 ? "Integration" : "Integrations"} are
                        available
                      </h3>
                    ) : null}
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row className="pad_0">
                  <Grid.Column width={16}>
                    <List
                      divided
                      verticalAlign="middle"
                      className="w_100 display-block"
                      style={{ borderRadius: "4px", border: "1px solid #ccc" }}
                    >
                      {integrationsArr && integrationsArr.length>0 ?
                        integrationsArr.map((m, i) => {
                          return (
                            <List.Item className="pad_10" key={i}>
                              <List.Content floated="right">
                                <Checkbox
                                  toggle
                                  name="inte1"
                                  // defaultChecked={m.isActive ? m.isActive : false}
                                  // checked={m.isActive ? m.isActive : false}
                                  checked={this.state.allIntegrations.some(
                                    (el) =>
                                      el._id === m._id && el.isActive
                                        ? el.isActive
                                        : false
                                  )}
                                  onChange={this.toggleChange}
                                  integration={m}
                                />
                              </List.Content>
                              <Image avatar className="mar_0" src={m.image} />
                              <List.Content>
                                <List.Content>{m.label}</List.Content>
                              </List.Content>
                            </List.Item>
                          );
                        }) :  <List.Item className="pad_10"> <span style={{"marginLeft":"145px"}}>No integrations added</span></List.Item>
                        }
                    </List>

                    {/* <List
                    divided
                    verticalAlign='middle'
                    className="w_100 display-block"
                    style={{ borderRadius: "4px", border: "1px solid #ccc" }}>
                    {
                      integrationsList &&
                        integrationsList.data.length !== 0 &&
                        account ? integrationsList.data.map((integration, i) => {
                          // {account.integrations.map(async index => (index._id === integration._id) ? (await this.setState({ checked: true })) : (await this.setState({ checked: false })))}

                        
                          return (
                            <List.Item className="pad_10" key={i}>
                              <List.Content floated='right'>
                                <div class="ui toggle checkbox">
                                  <input type="checkbox"
                                    name="public"
                                    onClick={(e, item) => this.toggleChange(e, account, integration)}
                                    checked={account &&
                                      account.integrations &&
                                      account.integrations.some(el => {

                                        return el.id._id === integration._id && el.id.isActive
                                      })}
                                  />
                                  <label> </label>
                                </div>
                              </List.Content>
                              <Image avatar className="mar_0" src={integration.image} />
                              <List.Content>{integration.label}</List.Content>
                            </List.Item>

                          )
                        })

                        : null
                    }
                  </List> */}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Modal.Content>
            <Divider />
            <Modal.Actions className="actionInFormcy">
              {/* <Button
              className="button-submit float-right"
              formNoValidate={true}
              id="deactivateBtn"
              // disabled={this.state.reason.length === 0}
              type="submit"
            >

              Save
            </Button> */}
              <Button
                id="cancelBtn"
                className="button-cancel"
                onClick={this.handleClose}
                type="button"
              >
                Close
              </Button>
            </Modal.Actions>
          </Form>

          <Modal
            onClose={this.closeDisableIntegrationModal}
            open={this.state.secondOpen}
            size="mini"
          >
            <Modal.Header>Disable Integration</Modal.Header>
            <Modal.Content>
              <h3>Are you sure you want to disable ?</h3>
              <Grid.Row className="">
                <Grid.Column>
                  <Form>
                    <TextArea
                      placeholder="Reason"
                      onChange={(e, value) => {
                        this.disableIntegrationReason(e, value);
                      }}
                    />
                  </Form>
                </Grid.Column>
              </Grid.Row>
            </Modal.Content>
            <Modal.Actions>
              <Button
                // icon='check'
                content="Close"
                onClick={this.closeDisableIntegrationModal}
              />
              <Button
                // icon='check'
                disabled={this.state.disabledIntegrationreason ? false : true}
                content="Ok"
                onClick={this.onDisableIntegration}
              />
            </Modal.Actions>
          </Modal>
        </Modal>
      </div>
    );
  }
}

export default ManageIntegrationsModal;
